import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const CartContext = createContext();

const CartProvider = ({ children }) => {
    const [cart, setCart] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [sessionId, setSessionId] = useState(localStorage.getItem("sessionId") || generateSessionId());

    useEffect(() => {
        localStorage.setItem("sessionId", sessionId);
        fetchCart();
    }, [sessionId]);

    function generateSessionId() {
        return `guest_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    }

    const fetchCart = async () => {
        try {
            const response = await axios.get("https://bloodinoureyes.com/api/cart", {
                headers: { "x-session-id": sessionId },
            });
            const items = response.data.cart.items || [];
            setCart(items);
            const total = items.reduce((sum, item) => sum + item.quantity, 0) || 0;
            setTotalItems(total);
        } catch (error) {
            console.error("Error fetching cart:", error);
        }
    };

    useEffect(() => {
        fetchCart();
    }, []);

    const addToCart = async (productId, size, quantity = 1) => {
        try {
            const response = await axios.post(
                `https://bloodinoureyes.com/api/cart/add/${productId}/${quantity}`,
                { size },
                { headers: { "x-session-id": sessionId } }
            );
            const items = response.data.cart.items;
            setCart(items);
            const total = items.reduce((sum, item) => sum + item.quantity, 0);
            setTotalItems(total);
        } catch (error) {
            console.error("Error adding to cart:", error);
        }
    };

    const updateQuantity = async (productId, size, quantity) => {
        if (quantity < 1) return; // Prevent negative or zero quantities
        try {
            const response = await axios.post(
                `https://bloodinoureyes.com/api/cart/add/${productId}/${quantity}`,
                { size },
                { headers: { "x-session-id": sessionId } }
            );
            const items = response.data.cart.items;
            setCart(items);
            const total = items.reduce((sum, item) => sum + item.quantity, 0);
            setTotalItems(total);
        } catch (error) {
            console.error("Error updating quantity:", error);
        }
    };

    const removeFromCart = async (productId, size) => {
        try {
            await axios.delete(`https://bloodinoureyes.com/api/cart/remove/${productId}/${size}`, {
                headers: { "x-session-id": sessionId },
            });
            fetchCart(); // Refresh cart after removal
        } catch (error) {
            console.error("Error removing item:", error);
        }
    };

    return (
        <CartContext.Provider value={{ cart, setCart, addToCart, updateQuantity, removeFromCart, totalItems }}>
            {children}
        </CartContext.Provider>
    );
};

export default CartProvider;
